import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface DashboardSectionProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function DashboardSection({
  title,
  description,
  actions,
  className,
  children,
}: DashboardSectionProps) {
  return (
    <section className={cn('flex flex-col gap-4', className)}>
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          <Text variant="cardTitle" className="text-primary-700">
            {title}
          </Text>
          {description && <Text variant="subtle">{description}</Text>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  );
}
